<template>
<!-- eslint-disable max-len -->
<div class="notification" :style="style">
  <div class="player-icon">
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <img
        v-if="character != null"
        class="player-icon-img"
        :src="resolveAssetPath(character.icon, 'characters')"
      />
    </transition>
  </div>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div class="decision-complete" v-html="notificationText">
    </div>
  </transition>
  <!-- <p class="player-icon-label">{{ `${player.character != null ? player.character.title : ''}${(player.character != null && player.role.title) ? ': ' : ''}${player.role.title && `${player.role.title}` || ''}` }}</p> -->
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    notification: { type: Object },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'metrics',
      'game'
    ]),
    _id() {
      return this.notification._id;
    },
    playerName() {
      return this.notification.playerName;
    },
    character() {
      return this.notification.character;
    },
    backgroundBanner() {
      return this.notification.backgroundBanner;
    },
    decisionTitle() {
      return this.notification.decisionTitle;
    },
    type() {
      return this.notification.type;
    },
    choices() {
      return this.notification.choices;
    },
    completed() {
      return this.notification.completed;
    },
    dateString() {
      let ds = '';
      if (this.completed) {
        const d = new Date(this.completed);
        if (d) {
          ds = d.toLocaleString();
        } else {
          ds = this.completed;
        }
      }
      return ds;
    },
    endCash() {
      return this.notification.endCash;
    },
    endRolesCash() {
      return this.notification.endRolesCash;
    },
    endMetrics() {
      return this.notification.endMetrics;
    },
    style() {
      return {
        'background-image': this.backgroundBanner ? `url(${this.resolveAssetPath(this.backgroundBanner, 'backgrounds')})` : 'none',
        'border-radius': '5px',
      };
    },
    notificationText() {
      console.log(this.choices);
      if (this.dateString && this.playerName) {
        let text =
          `${(this.decisionTitle) ? `Decision: ${this.decisionTitle}<br>` : ''}At ${this.dateString}, ${this.playerName} chose:<br>`;
        if (this.choices && this.choices.length) {
          this.choices.forEach((ch) => {
            if (ch && ch.effectText) {
              text += `${ch.title} (${ch.effectText})<br>`;
            } else if (ch) {
              text += `${ch.title}<br>`;
            }
          });
        } else {
          text += '(No choice selected)<br>';
        }

        let scoreText = '(';
        if (!(this.game.hideMetricsFromDecisionHistory)) {
          let first = true;
          if (this.endMetrics && this.endMetrics.length) {
            this.endMetrics.forEach((m) => {
              if (!(m.hidden)) {
                const metric = this.metrics[m._id];
                if (metric) {
                  if (!first) scoreText += ', ';
                  first = false;
                  scoreText += `${metric.title}: ${m.value}`;
                }
              }
            });
          }
          if (this.endCash) {
            if (!first) scoreText += ', ';
            first = false;
            scoreText += `Cash Reserve: $${this.endCash.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
          }
          scoreText += ')';
        }
        if (scoreText.length > 6) {
          text += scoreText;
        }

        return text;
      }
      return ''; // failsafe for completely malformed notification
    }
  },
  methods: {
    ...mapActions([
      'setUnreadNotificationCount',
    ]),
  },
  created() {
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.fadeInUp {
  animation-duration: 0.8s;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.fadeOutUp {
  animation-duration: 0.4s;
  animation-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);
}

.notification {
  width: 98%;
  margin-left: 1%;
  height: fit-content;
  background-repeat: no-repeat;
  background-size: cover;
  border: 4px solid var(--primaryColor);
  margin-bottom: 12px;
  position: relative;
  box-shadow: 0 0 10px 1px black;
  transition: border-color 1s;
  border-radius: 5px;
}
.player-icon {
  height: 142px;
  width: 272px;
  float: right;
  position: relative;
  padding: 0 80px;
}
.player-icon-img {
  height: 100%;
  position: relative;
}
.player-icon-label {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 200px;
  background-color: white;
  color: var(--primaryColor);
  margin: 5px 20px 5px 5px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  box-shadow: 3px -3px 0px 0px var(--primaryColor);
}
.decision-complete {
  position: absolute;
  background-color: white;
  color: black;
  border: 3px solid black;
  font-size: 18px;
  line-height: 118%;
  text-align: center;
  padding: 8px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  width: 435px;
  margin: 0 0 0 50px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.decision-complete::before {
  position: absolute;
  top: 40%;
  right: -64px;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 16px 0 16px 64px;
  border-color: transparent transparent transparent black;
}
.decision-complete::after {
  position: absolute;
  top: 41%;
  right: -48px;
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 14px 0 14px 56px;
  border-color: transparent transparent transparent white;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Notification.vue